import React from 'react';
import { Popover } from '@fx-ui/fine-design';
import { MemberAvatar as MemberAvatarBase, MemberAvatarProps } from '@fx-ui/jdy-design-biz';
import MemberCard from '../member-card';
import classNames from 'classnames';
import { tracker } from '../../utils';
import { TRACKER } from '../../constants';

interface IMemberAvatarProps extends MemberAvatarProps {
    /**
     * 是否显示成员信息卡片
     */
    showViewCard?: boolean;
    /**
     * 触发成员信息卡片方式
     * @default hover
     */
    trigger?: 'hover' | 'click';
    triggerClassName?: string;
    memberId?: string;
}

const MemberAvatar: React.FC<IMemberAvatarProps> = (props) => {
    const {
        showViewCard,
        memberId,
        trigger = 'hover',
        triggerClassName,
        className,
        ...otherProps
    } = props;

    const renderMemberAvatar = (cls?: string) => {
        return <MemberAvatarBase className={cls} {...otherProps} />;
    };

    if (showViewCard && memberId) {
        return (
            <Popover
                trigger={trigger}
                placement="bottom-left"
                hasPadding={false}
                arrow={false}
                content={<MemberCard memberId={memberId} />}
                onAfterPopupShow={() => {
                    if (trigger === 'click') {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_CLICK);
                    } else {
                        tracker(TRACKER.MEMBER_CARD_SETTINGS_HOVER);
                    }
                }}
            >
                <span
                    className={triggerClassName}
                    style={{
                        display: 'inline-flex',
                        cursor: 'pointer'
                    }}
                >
                    {renderMemberAvatar(className)}
                </span>
            </Popover>
        );
    }

    return renderMemberAvatar(classNames(triggerClassName, className));
};

export default MemberAvatar;
